import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Button, Checkbox } from "@mui/material";
import TextInput from "../../Components/InputComponents/TextInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import TextAreaInput from "../../Components/InputComponents/TextAreaInput";
import { decryptId, encryptId } from "../../Components/CryptoComponent";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const CreateJobLinking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  // const decryptedId = decryptId(decodeURIComponent(id));

  const decryptedId = location?.state?.decryptedId;
  const Tab = location?.state?.Tab;
  const selectedJobID = location?.state?.selectedJobID;
  const decryptedJAId1 = location?.state?.decryptedJAId;
  const selectedJobName = location?.state?.selectedJobName;
  const [isDisabled, setIsDisabled] = useState(false);

  const [jobdata, setjobdata] = useState({
    job: "",
    interviewDate: "",
    JA_Cvsent: "",
    JA_OfferletterStatus: "",
    JA_Shortlisted: "",
    comment: "",
    status: "",
  });

  const [JobList, setJobList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [offerStatusList, setOfferStatusList] = useState([]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const mandatoryFields = [
      { field: "job", label: "Job" },
      { field: "status", label: "Status" },
    ];

    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{20}$/; // 20-digit phone validation

    for (let { field, label, type } of mandatoryFields) {
      const value = jobdata[field];

      if (!value) {
        formErrors[field] = `${label} is required.`;
      } else if (type === "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      }

      if (jobdata.interviewDate == "Invalid Date") {
        formErrors[`interviewDate`] = `Date format is Invalid.`;
      }
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      // Display the errors as toast notifications
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }

    return true;
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setjobdata({
      ...jobdata,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsDisabled(true);
      axiosAPI
        ?.post("/Candidate/addCandidateJobLinking", {
          JA_CandidateId: decryptedId,
          JA_JobId: jobdata?.job,
          JA_InterviewDate: jobdata?.interviewDate
            ? jobdata?.interviewDate
            : null,
          JA_Comment: jobdata?.comment,
          JA_StatusId: jobdata?.status,
          JA_Cvsent: jobdata?.JA_Cvsent ? jobdata?.JA_Cvsent : 0,
          JA_OfferletterStatus: jobdata?.JA_OfferletterStatus
            ? jobdata?.JA_OfferletterStatus
            : 0,
          JA_Shortlisted: jobdata?.JA_Shortlisted ? jobdata?.JA_Shortlisted : 0,
        })
        .then((res) => {
          if (res?.data?.data?.success) {
            successNotify(res?.data?.data?.message);
            const encrypted = encodeURIComponent(encryptId(decryptedId));
            navigate(`/Candidates/View/${encrypted}`, {
              state: {
                decryptedId: encrypted,
                Tab: Tab,
                selectedJobID: selectedJobID,
                decryptedJAId: decryptedJAId1,
                selectedJobName: selectedJobName,
                selectedJobIndex: selectedJobListId,
                selectedProfileTab:selectedProfileTab
              },
            });
          } else {
            infoNotify(res?.data?.data?.message);
          }
          setIsDisabled(false);
        })
        .catch((err) => {
          errorNotify("Something went Wrong!");
          setIsDisabled(false);
        });
    }
  };

  const getJobs = async () => {
    try {
      const res = await axiosAPI.get(`/Job/active/list`);
      setJobList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getStatus = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/list`);
      setStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const GetOfferStatusList = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/offerStatuslist`);
      setOfferStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };
  const [selectedProfileTab, setSelectedProfileTab] = useState(0);
  const [selectedJobListId, setSelectedJobListId] = useState("");
  
  useEffect(() => {
    if (location?.state?.selectedProfileTab) {
      setSelectedProfileTab(location?.state?.selectedProfileTab);
    }
    if (location?.state?.selectedJobIndex){
      setSelectedJobListId(location?.state?.selectedJobIndex)
    }
  }, [location?.state]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getJobs();
    getStatus();
    GetOfferStatusList();
  }, []);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          marginBottom: 3,
          fontFamily: "Geist, sans-serif",
        }}
      >
        Add Job Linking
      </Typography>

      {/* ============================================================================================================================================================================== */}
      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        {/*Job */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Select a Job <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={jobdata.job}
            name="job"
            onChange={handleInputChange}
            options={JobList?.map((item) => ({
              value: item?.JD_Id,
              label: `${item?.JD_Title} (${item?.JD_JobId})`,
            }))}
            placeholder="Select a Job"
            error={!!errors?.job}
          />
        </Grid>

        {/* Interview Date */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Interview Date
          </Typography>
          <TextInput
            label="Interview Date"
            placeholder="Interview Date"
            name="interviewDate"
            value={jobdata.interviewDate}
            onChange={handleInputChange}
            type="date"
            dateRestriction="future"
          />
        </Grid>

        {/*  Interview Status */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Interview Status <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={jobdata.status}
            name="status"
            onChange={handleInputChange}
            options={statusList?.map((item) => ({
              value: item?.JASL_Id,
              label: item?.JASL_Name,
            }))}
            placeholder="Select Status"
            error={!!errors?.status}
          />
        </Grid>

        {/* CV Sent? */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            CV Sent?
          </Typography>
          <SelectInput
            value={jobdata.JA_Cvsent}
            name="JA_Cvsent"
            onChange={handleInputChange}
            options={[
              { value: 1, label: "Yes" },
              { value: 2, label: "No" },
            ]}
            placeholder="CV Sent?"
          />
        </Grid>

        {/*  Shortlisted */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Shortlisted
          </Typography>
          <SelectInput
            value={jobdata.JA_Shortlisted}
            name="JA_Shortlisted"
            onChange={handleInputChange}
            options={[
              { value: 1, label: "Yes" },
              { value: 2, label: "No" },
            ]}
            placeholder="Shortlisted"
          />
        </Grid>

        {/*  Offer Letter Status */}
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Offer Letter Status
          </Typography>

          <SelectInput
            value={jobdata.JA_OfferletterStatus}
            name="JA_OfferletterStatus"
            onChange={handleInputChange}
            options={offerStatusList?.map((item) => ({
              value: item?.JOS_Id,
              label: item?.JOS_Name,
            }))}
            placeholder="Select Offer Letter Status"
          />
        </Grid>

        {/* Comment */}
        <Grid item xs={12} sm={12} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Comment
          </Typography>
          <TextAreaInput
            label="comment"
            placeholder="Enter your Comment"
            name="comment"
            value={jobdata?.comment}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              const encrypted = encodeURIComponent(encryptId(decryptedId));
              navigate(`/Candidates/View/${encrypted}`, {
                state: {
                  decryptedId: encrypted,
                  Tab: Tab,
                  selectedJobID: selectedJobID,
                  decryptedJAId: decryptedJAId1,
                  selectedJobName: selectedJobName,
                   selectedJobIndex: selectedJobListId,
                selectedProfileTab:selectedProfileTab
                },
              });
            }}
          >
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
            disabled={isDisabled}
          >
            {isDisabled ? "Saving" : "Save"}
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CreateJobLinking;
